import { Component } from '@angular/core';

@Component({
  selector: 'app-rules-investments-and-business',
  templateUrl: './rules-investments-and-business.component.html',
  styleUrl: './rules-investments-and-business.component.scss'
})
export class RulesInvestmentsAndBusinessComponent {
  items = [
    {
      title: ' قانون الاستثمار الجديد',
      content: 'يهدف قانون الإستثمار الجديد لزيادة نسبة المنتج المحلي ورفع مستوى المنافسة ومحاربة الإحتكار و يمنح حوافز إستثنائية للمشروعات كثيفة العمالة و المناطق الجغرافية الاكثر احتياجا للتنمية وكذلك للمشروعات الصغيرة، وخصوصا مشروعات الشباب والمرأة ورواد الأعمال و المشروعات الناشئة، كما استحدث المناطق التكنولوجية الخاصة . و يحدد القانون مدة زمنية محددة للخدمات المقدمة من مجمع خدمات الاستثمار المنصوص في القانون و يمنح صلاحيات للجهات الادارية الممثلة في المجمع لسرعة اتخاذ القرار و تمرير الموافقات و تفعيل خدمة الشباك الواحد و استحدث نظام مكاتب الاعتماد لفحص مستندات المستثمرين و لتسهيل اجراءات الاستثمار. كما قام القانون الجديد بإرساء و تحديد قواعد الحوكمة و الشفافية بالنسبة لمجالس ادارة الهيئة و المناطق التابعة لها.        ',
      mainLinksLabel: 'لقراءة المزيد عن ,',
      mainLinks: [
        { text: 'قانون الاستثمار 72 لسنة 2017 وفق التعديلات الأخيرة', url: 'assets/قانون الاستثمار 72 لسنة 2017 وفق التعديلات الأخيرة.pdf' },
        { text: 'اللائحة التنفيذية لقانون', url: 'assets/اللائحة التنفيذية لقانون الاستثمار وفق التعديلات الأخيرة.pdf' }
      ],
      subLinksLabel: 'الاستثمار وفق التعديلات الأخيرة',
      subLinks: [
        { text: 'قرار 4427 لسنة 2022', url: 'assets/قرار 4427 لسنة 2022.pdf' },
        { text: 'قرار رئيس مجلس الوزراء رقم 2928 لسنة 2022', url: 'assets/قرار رئيس مجلس الوزراء رقم 2928 لسنة 2022.pdf' },
        { text: 'قرار 77 لسنة 2023', url: 'assets/قرار 77 لسنة 2023.pdf' },
        { text: 'قرار رقم 1 لسنة 2024', url: 'assets/قرار رقم 1 لسنة 2024.pdf' },
        { text: 'قرار رئيس الوزراء 1203 لسنة 2024', url: 'assets/قرار رئيس الوزراء 1203 لسنة 2024.pdf' },
        { text: 'قرار رئيس الوزراء 2562 لسنة 2024', url: 'assets/قرار رئيس الوزراء 2562 لسنة 2024.pdf' }
      ],
      expanded: false,
    },
    {
      title: '  قانون البيئة',
      content: 'تزايد القلق بشأن البيئة وحمايتها في السنوات الأخيرة، سواءٌ في أروقة الحكومة أو بين الجمهور المصري بوجهٍ عام، وذلك بفضل وعي جديد بأهمية الموارد الطبيعية، فضلاً عن الرغبة في حماية رفاهية الشعب المصري، ويعكس قانون البيئة رقم 4 لسنة 1994 هذا الاتجاه المتنامي حيث يمنح القانون حوافز للقائمين على تنفيذ أنشطة أو مشروعات حماية البيئة، كما يفرض عقوبات على المنتهكين لأحكامه.',
      mainLinksLabel: 'لقراءة المزيد عن القانون ,',
      mainLinks: [
        { text: ' إضغط هنا', url: 'assets/قانون البيئة.pdf' },
      ],
      expanded: false,
    },
    {
      title: '  قانون التعدين  ',
      content: 'تٌعمل أحكام قانون التعدين والثروة المعدنية رقم 198 لسنة 2014 في شأن الثروة المعدنية وخامات المناجم والمحاجر والملاحات، كما تسري على المواد النووية والنظائر المشعة والتشريعات المنظمة لها دون غيرها.',
      mainLinksLabel: 'لقراءة المزيد عن القانون ,',
      mainLinks: [
        { text: 'ضغط هنا', url: 'assets/elta3den (2).pdf' },
      ],
      expanded: false,
    },
    {
      title: ' قانون الضريبة على الدخل   ',
      content: 'أدخل القانون الجديد للضريبة على الدخل رقم 91 لسنة 2005 تعديلات جوهرية على القواعد السابقة لضريبة الدخل في مصر، حيث خفض الضرائب على الأشخاص والشركات بنسبة 50% ليصل الحد الأقصى إلى 20%. كما ألغى جميع الإعفاءات على ضرائب الدخل الواردة بقانون ضمانات وحوافز الاستثمار رقم 8 لسنة 1997 فيما يتعلق بالمؤسسات التي أدرجت بعد دخول القانون حيز التنفيذ (بمعنى الإعفاءات الضريبية والتشريعات الموحدة).',
      mainLinksLabel: 'قانون الضريبة على الدخل ',
      mainLinks: [
        { text: 'اضغط هنا ', url: 'assets/قانون الضريبة على الدخل (1).pdf' },
      ],
      expanded: false,
    },
    {
      title: ' قانون العمل  ',
      content: 'يتم تنظيم سوق العمل في مصر من خلال قانون العمل الموحد الجديد رقم 12 لسنة 2003، ويستهدف القانون الجديد زيادة مشاركة القطاع الخاص، مع تحقيق التوازن بين حقوق العاملين وحقوق أصحاب العمل.',
      mainLinksLabel: 'لقراءة المزيد عن القانون ,',
      mainLinks: [
        { text: 'اضغط هنا ', url: 'assets/قانون العمل.pdf' },
      ],
      expanded: false,
    },
    {
      title: '  قوانين المناطق الاقتصادية ',
      content: 'أقر البرلمان المصري في مايو من العام 2002 قانون المناطق الاقتصادية الخاصة رقم 83 لسنة 2002، والذي ينص على إقامة مناطق خاصة للأنشطة الصناعية والزراعية والخدمية التي تهتم بأسواق التصدير في المقام الأول، ويسمح القانون للشركات العاملة في هذه المناطق باستيراد المعدات الرأسمالية، والمواد الخام، والسلع الوسيطة معفاةً من الرسوم الجمركية، وتخضع الشركات التي تم تأسيسها في المناطق الجديدة أيضًا لضرائب منخفضة على الشركات، كما تعفى من ضرائب المبيعات والضرائب غير المباشرة، كما ستعمل هذه الشركات في ظل إجراءاتٍ عمالية أكثر مرونة، كما تتمتع بمجموعةٍ أخرى من الحوافز. وقد صدرت اللائحة التنفيذية للقانون في سبتمبر 2002، وتعمل حاليًا منطقة اقتصادية خاصة واحدة في منطقة شمال غرب خليج السويس، وتتولى إدارتها الهيئة العامة للمنطقة الاقتصادية الخاصة بشمال غرب خليج السويس.',
      mainLinksLabel: 'لقراءة المزيد عن القانون ,',
      mainLinks: [
        { text: 'اضغط هنا ', url: 'قانون المناطق الاقتصادية.pdf' },
      ],
      expanded: false,
    },
    {
      title: ' قانون تمويل مشروعات متناهية الصغر',
      content: 'يقصد بالتمويل متناهي الصغر كل تمويل لأغراض اقتصادية إنتاجية أو خدمية أو تجارية, وبالقيمة التي يحددها مجلس إدارة الهيئة العامة للرقابة المالية, وفي 13 نوفمبر 2014 تم نشر بالجريدة الرسمية قرار رئيس الجمهورية بالقانون 141 لسنة 2014 بتنظيم نشاط التمويل متناهي الصغر, وقد بدأت الهيئة العامة للرقابة المالية في صياغة القرارات التنفيذية والضوابط اللازمة لتنظيم النشاط وتحديد متطلبات الترخيص لكل من الشركات والجمعيات الأهلية.',
      mainLinksLabel: 'لقراءة المزيد عن القانون ,',
      mainLinks: [
        { text: 'اضغط هنا', url: 'assets/قانون تمويل مشروعات متناهية الصغر.pdf' }
      ],
      expanded: false,
    },
    {
      title: ' قانون حقوق الملكية الفكري',
      content: 'أقر مجلس الشعب المصري في مايو من العام 2002 قانون حقوق الملكية الفكرية الجديد رقم 82 لسنة 2002، والذي يهدف إلى جعل النظام القانوني المصري الخاص بحقوق الملكية الفكرية متماشيًا مع التزاماتها الواردة بالاتفاقية المتعلقة بالجوانب التجارية لحقوق الملكية الفكرية (التربس) في منظمة التجارة العالمية. ويهدف القانون الجديد لحماية حقوق الملكية الفكرية إلى خلق البيئة التي من شأنها أن تشجع على الإبداع وتعزز الاستثمار الأجنبي المباشر, ويتألف قانون حقوق الملكية الفكرية الجديد من 205 مادة يوحد ويسود على القوانين الحالية الخاصة بحقوق الملكية الفكرية, ويتضمن القانون أربعة أقسام هي: العلامات التجارية, وحقوق التأليف والنشر, وبراءات الاختراع, والأصناف النباتية المستنبطة.',
      mainLinksLabel: 'لقراءة المزيد عن القانون ,',
      mainLinks: [
        { text: 'قانون رقم 82 لسنة 2002', url: 'assets/قانون رقم 82 لسنة 2002.pdf' },
        { text: 'قرار رئيس مجلس الوزراء رقم 2202 لسنة 2006', url: 'assets/قرار رئيس مجلس الوزراء رقم 2202 لسنة 2006.pdf' }
      ],
      expanded: false,
    },
    {
      title: ' قانون الشركات',
      content: 'تسري أحكام هذا القانون على شركات المساهمة وشركات التوصية بالأسهم والشركات ذات المسئولية المحدودة, ويلغى القانون رقم 26 لسنة 1954 بشأن بعض الاحكام الخاصة بشركات المساهمة وشركة التوصية بالأسهم والشركات ذات المسئولية المحدودة, كما يلغى القانونان رقم 244 لسنة 1960 بشأن الاندماج في شركات المساهمة, ورقم 137 لسنة 1961 بتشكيل مجلس إدارة شركات المساهمة, وكذلك كل حكم يتعارض مع أحكام قانون رقم 159 ولائحته التنفيذية.',
      mainLinksLabel: 'لقراءة المزيد عن القانون ,',
      mainLinks: [
        { text: 'قانون رقم 159 لسنة 1981', url: 'assets/قانون رقم 159 لسنة 1981.pdf' },
        { text: 'قرار رئيس الجمهورية بالقانون رقم 17 لسنة 2015', url: 'assets/قرار رئيس الجمهورية بالقانون رقم 17 لسنة 2015.pdf' }
      ],
      expanded: false,
    }
  ];

  toggle(item: any) {
    item.expanded = !item.expanded;
  }
}
